// extracted by mini-css-extract-plugin
module.exports = {"icon":"ChannelsTooltip_icon__fxxSt","buttonWrap":"ChannelsTooltip_buttonWrap__14vug","button":"ChannelsTooltip_button__os8-C"};